import React, { useState } from 'react'

// project-imports
import { GoogleAnalyticsEnum, pageView } from '../../utils/google-analytics';
import SEO from '../../common/SEO';
import Layout from '../../common/Layout';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';
import PrivacyPolicyStencil from './PrivacyPolicyStencil';
import SectionTitle from '../../components/sectionTitle/SectionTitle';


const PrivacyPolicy = () => {

    // State variable initialization 
    const [stencilLoading, setStencilLoading] = useState(true);

    // Loading timeout 
    setTimeout(() => {
        setStencilLoading(false);
    }, 1000);

    if (stencilLoading) {
        // Loading stencil 
        return <PrivacyPolicyStencil />;
    }
    return (
        <>
            {pageView(window.location.pathname, GoogleAnalyticsEnum.PRIVACY_POLICY)}

            <SEO title="Longswitch Academy Privacy Policy" url={process.env.PUBLIC_URL + '/privacy-policy'} /> {/* Set SEO title */}
            <Layout searchDisable={true}>
                <BreadcrumbOne
                    title="Privacy Policy" // Breadcrumb title
                    rootUrl="/"
                    parentUrl="Home"
                    googleEnum={GoogleAnalyticsEnum.PRIVACY_POLICY_TO_HOME}
                    currentUrl="Privacy Policy"
                />
                <div className="edu-privacy-policy-area edu-privacy-policy edu-section-gap bg-color-white">
                    <div className="container eduvibe-animated-shape mb--130">
                        <SectionTitle
                            classes="text-center"
                            slogan="Your privacy matters to us. This page explains what information we collect, why we collect it, and how we keep it safe."
                            title="Privacy Policy"
                        />
                        <div className="row y-gap-30 pt--50">
                            <div className="content">
                                <div className="thumbnail mb--50">
                                    <img className="radius-small w-100" src="/images/others/privacy-policy.png" alt="Privacy Policy" />

                                </div>

                                <h4 className="title">Privacy Policy</h4>
                                <p className="fs-15">Thank you for visiting Longswitch Academy (hereinafter referred to as "we", "us", or "our"). Your privacy is important to us. This Privacy Policy outlines the types of personal information we collect, how it is used, and the measures we take to protect it.</p>

                                <h4 className="title">Information We Collect</h4>
                                <ol>
                                    <li className="fs-15"><b>Personal Information:</b> We may collect personal information such as your name, email address, and any other information you provide when you register for our services or communicate with us.</li>
                                    <li className="fs-15"><b>Usage Information:</b> We may collect information about your interactions with our content, including videos watched, comments, likes, and other interactions on our YouTube channel.</li>
                                    <li className="fs-15"><b>Technical Information:</b> We may automatically collect certain technical information, such as your IP address, device information, browser type, and operating system.</li>
                                </ol>

                                <h4 className="title">How We Use Your Information</h4>
                                <ol>
                                    <li className="fs-15"><b>To Provide Services:</b> We use the information we collect to provide you with access to our tech education content, respond to your inquiries, and improve our services.</li>
                                    <li className="fs-15"><b>Communication:</b> We may use your contact information to communicate with you about our services, promotions, updates, and other relevant information.</li>
                                    <li className="fs-15"><b>Analytics:</b> We may use aggregated and anonymized information for analytical purposes to understand how users interact with our content and improve our offerings.</li>
                                </ol>

                                <h4 className="title">Information Sharing</h4>
                                <ol>
                                    <li className="fs-15"><b>Third Parties:</b> We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except as required by law or to comply with legal obligations.</li>
                                    <li className="fs-15"><b>Service Providers:</b> We may engage third-party service providers to assist us in delivering our services, and we may share your information with them only to the extent necessary to provide these services.</li>
                                </ol>

                                <h4 className="title">Data Security</h4>
                                <p className="fs-15">We take reasonable measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction. However, no method of transmission over the internet or electronic storage is completely secure, and we cannot guarantee absolute security.</p>

                                <h4 className="title">Changes to this Privacy Policy</h4>
                                <p className="fs-15">We reserve the right to update or modify this Privacy Policy at any time. Any changes will be effective immediately upon posting the updated Privacy Policy on our website.</p>

                                <h4 className="title">Contact Us</h4>
                                <p className="fs-15">If you have any questions or concerns regarding this Privacy Policy or our privacy practices, please contact us at <a href={process.env.REACT_APP_OFFICIAL_EMAIL_ADDRESS}>{process.env.REACT_APP_OFFICIAL_EMAIL_ADDRESS}</a>.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}
export default PrivacyPolicy;